import React from "react";
import styles from "./ads.module.css";
import infiniteAds from "./image/infinitepay.png";
import melhorEnvioAds from "./envio.png";

function AdsPage() {
    return (
        <section className={styles.adsSection}>
            <div className={styles.container}>
                <h3 className={styles.sectionTitle}>Segurança e Logística de Alto Nível</h3>
                
                <div className={styles.adsGrid}>
                    {/* Card InfinitePay */}
                    <div className={styles.adCard}>
                        <div className={styles.logoWrapper}>
                            <img src={infiniteAds} alt="InfinitePay" />
                        </div>
                        <div className={styles.info}>
                            <h4>Pagamento 100% Blindado</h4>
                            <p>
                                Utilizamos a tecnologia da <strong>InfinitePay</strong> para garantir 
                                criptografia total em seus dados financeiros e aprovação imediata.
                            </p>
                        </div>
                    </div>

                    {/* Card Melhor Envio */}
                    <div className={styles.adCard}>
                        <div className={styles.logoWrapper}>
                            <img src={melhorEnvioAds} alt="Melhor Envio" />
                        </div>
                        <div className={styles.info}>
                            <h4>Envio Estratégico Garantido</h4>
                            <p>
                                Parceria com <strong>Melhor Envio</strong> para entregar seu equipamento 
                                com rapidez, seguro total e rastreio detalhado de ponta a ponta.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdsPage;